import { mapActions } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ParsedAppToken() {
            let base64Url = sessionStorage.appToken.split('.')[1];
            let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            return JSON.parse(jsonPayload);
        },
        Username() { return this.ParsedAppToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name']; },
        ImpersonatedUsername() { return this.ParsedAppToken['ImpersonatedUsername']; },
        DisplayName() { return this.ParsedAppToken['DisplayName']; },
        ImpersonatedDisplayName() { return this.ParsedAppToken['ImpersonatedDisplayName']; },
        EffectiveUsername() { return this.ImpersonatedUsername || this.Username; },
        EffectiveDisplayName() { return this.ImpersonatedDisplayName || this.DisplayName; },
        HasGroupMemberships() { return this.GroupMemberships.length > 0 },
        GroupMemberships() { return this.ParsedAppToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || []; },
        IsStaff() { return this.GroupMemberships.indexOf('Staff') > -1 || false; },
        IsStudent() {
            return this.GroupMemberships.indexOf('Mailing List - All Students') > -1
                || this.GroupMemberships.indexOf('Pre-Registered Students') > -1
                || false;
        },
        IsAuthorised() {
            switch (sessionStorage.loginMethod) {
                case 'pin': return this.IsStaff || this.IsStudent;
                case 'studentID': return this.IsStaff;
                default: return this.IsStudent;
            }
        }
    },
    methods: {
        ...mapActions({
            FetchAppTokenByAccessToken: 'appApi/FetchAppTokenByAccessToken',
            FetchAppTokenByUsernamePIN: 'appApi/FetchAppTokenByUsernamePIN',
        }),
        LoadAppTokenByAccessToken() {
            eventBus.$emit('app-token-fetch:started');
            this.FetchAppTokenByAccessToken({ AccessToken: sessionStorage.accessToken, StudentID: sessionStorage.studentID })
                .then(() => eventBus.$emit('app-token-fetch:success'))
                .catch(error => {
                    eventBus.$emit('app-token-fetch:failed');
                    eventBus.$emit('console:error', error);
                })
                .finally(() => eventBus.$emit('app-token-fetch:finished'));
        },
        LoadAppTokenByUsernamePIN(username, pin) {
            eventBus.$emit('app-token-fetch:started');
            this.FetchAppTokenByUsernamePIN({ Username: username, PIN: pin })
                .then(() => eventBus.$emit('app-token-fetch:success'))
                .catch(error => {
                    eventBus.$emit('app-token-fetch:failed');
                    eventBus.$emit('console:error', error);
                })
                .finally(() => eventBus.$emit('app-token-fetch:finished'));
        },
        ReacquireAppToken() {
            if (sessionStorage.appToken != null) {
                let tokens = sessionStorage.appToken?.split('.');

                if (tokens.length > 1) {
                    let segment2 = JSON.parse(atob(tokens[1]));
                    let expiryDate = new Date(segment2.exp * 1000);

                    if (expiryDate != null) {
                        let difference = expiryDate - new Date();

                        if (difference <= 0) {
                            clearInterval(this.appTokenIntervalID);
                            sessionStorage.removeItem('appToken');

                            if (sessionStorage.accessToken?.length > 0) this.LoadAppTokenByAccessToken();
                            else this.GetAccessToken(this.account);
                        }
                    }
                }
            }
        }
    }
};